import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CommissionIcon from '@material-ui/icons/LocalOffer'
import { FlexDataItem } from 'components/FlexDataView'
import Typography from '@material-ui/core/Typography'
import { Progress } from './Progress'
import StyleSheet from 'styles'
import {NumberDisplay} from 'components/numbers'

export class Commission extends PureComponent {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () => {
    const {dealSheet} = this.props
    const isEquity = dealSheet.typeOfIssuance === 'equity'
    return (
      <FlexDataItem size="large">
        <Typography variant='subtitle1'><CommissionIcon />Commission</Typography>
          <div className={styles.columns}>
            <div>
              <dl>
                <dt>{dealSheet.currency.code} Expected</dt>
                <dd><NumberDisplay prefix={dealSheet.currency.prefix} suffix={dealSheet.currency.code}>{dealSheet.organisationCoinCommissionExpected}</NumberDisplay></dd>
                <dt>{dealSheet.currency.code} Received</dt>
                <dd><NumberDisplay prefix={dealSheet.currency.prefix} suffix={dealSheet.currency.code}>{dealSheet.organisationCoinCommissionReceived}</NumberDisplay></dd>
              </dl>
              <Progress className={styles.progress} value={dealSheet.organisationCoinCommissionReceived}
                        total={dealSheet.organisationCoinCommissionExpected} totalLabel="Expected"
                        valueLabel="Received" showKey/>
            </div>
            {!isEquity &&
            <div>
              <dl>
                <dt>{dealSheet.ticker} Expected</dt>
                <dd><NumberDisplay suffix={dealSheet.ticker}>{dealSheet.organisationTokenCommissionExpected}</NumberDisplay></dd>
                <dt>{dealSheet.ticker} Received</dt>
                <dd><NumberDisplay suffix={dealSheet.ticker}>{dealSheet.organisationTokenCommissionReceived}</NumberDisplay></dd>
              </dl>
              {dealSheet.organisationTokenCommissionExpected > 0 &&
              <Progress className={styles.progress} value={dealSheet.organisationTokenCommissionReceived}
                        total={dealSheet.organisationTokenCommissionExpected} totalLabel="Expected"
                        valueLabel="Received" showKey/>
              }
            </div>
            }
        </div>
      </FlexDataItem>
    )
  }
}

const styles = StyleSheet({
  progress: {
    marginLeft: 15,
    marginRight: 15,
  },
  columns: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      flex: 1,
      minWidth: 220,
      maxWidth: 660
    }
  }
})